import React from "react"
import { grey100, red500, green500, grey50, grey500 } from "material-ui/styles/colors"
import { IQuestion } from "../../../models"
import ReportIcon from "material-ui/svg-icons/content/report"
import { Chip } from "material-ui"
import strings from "../../../localization/strings"
interface IProps {
    question: IQuestion
    questions: IQuestion[]
    btn1Ids: string[]
    btn2Ids: string[]
}

export default class PunchQuestionItemAnswerHTMLViewer extends React.Component<IProps, {}> {
    private identifier
    constructor(props: IProps) {
        super(props)
        this.identifier = props.question.GroupId
    }

    componentDidMount() {
        const questionViewer = document.getElementById(this.identifier)
        questionViewer.innerHTML = this.props.question.Body
    }

    render() {
        const btn1Clicked = (this.props.btn1Ids || []).find(i => this.props.questions.filter(e => e.GroupId === this.props.question.GroupId).find(e => e.GUId === i)) !== undefined
        const btn2Clicked = (this.props.btn2Ids || []).find(i => this.props.questions.filter(e => e.GroupId === this.props.question.GroupId).find(e => e.GUId === i)) !== undefined
        const btnClicked = btn1Clicked || btn2Clicked
        const exceptionBtnClicked = btnClicked && (
            btn1Clicked ?
                (this.props.question.Btn1Action === -2 || this.props.question.Btn1Action === -1 || (this.props.question.Btn1Action >= 0 && this.props.question.CreateBtn1Exception)) :
                (this.props.question.Btn2Action === -2 || this.props.question.Btn2Action === -1 || (this.props.question.Btn2Action >= 0 && this.props.question.CreateBtn2Exception))
        )
        return (
            <div style={{ padding: 15, backgroundColor: grey100, display: "flex" }}>
                <div style={{ marginRight: 10, minWidth: 20 }}>
                    <Chip
                        backgroundColor={btnClicked ? exceptionBtnClicked ? red500 : green500 : grey500}
                        labelStyle={{ color: grey50 }}
                    >
                        {btnClicked ?
                            btn1Clicked ?
                                this.props.question.BtnLabel1 :
                                this.props.question.BtnLabel2 :
                            strings.No_Answer
                        }
                    </Chip>
                </div>
                <div
                    id={this.identifier}
                    style={{ fontSize: 17, flex: 1 }}
                />
                <div style={{ width: 20 }}>
                    {exceptionBtnClicked &&
                        (btn1Clicked ?
                            this.props.question.Btn1Action === -1 :
                            this.props.question.Btn2Action === -1
                        ) &&
                        <ReportIcon style={{ fill: red500 }} />
                    }
                </div>
            </div>
        )
    }
}